import React from 'react'
import { FieldLabel } from '../form/index'
import StationSearchSelect from './StationSearchSelect'

const StationSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={StationSearchSelect} />
)

export default StationSearchSelectField
